import React, { useState } from 'react'
import AddBudgetCategory from './AddBudgetCategory'


import AddBudgetElement from './AddBudgetElement'

function BudgetEditor() {

    const [type, setType] = useState("income")

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-6">
                    <button onClick={() => setType("income")} className={`btn btn-success btn-block ${type === "income" && "active"}`}>Inntekt</button>
                </div>
                <div className="col-6">
                    <button onClick={() => setType("expense")} className={`btn btn-danger btn-block ${type === "expense" && "active"}`}>Utgift</button>
                </div>
            </div>
            {type === "income" && <AddBudgetElement type="income" />}
            {type === "expense" && <AddBudgetElement type="expense"/>}

            <div className="my-5">
                <h2 className="my-2">Legg til kategori</h2>
                <AddBudgetCategory />
            </div>

        </React.Fragment>
    )
}
export default BudgetEditor